// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chip_wrapper__DHj_H","icon":"Chip_icon__rsRTW","text":"Chip_text__G__yD"};